export const emissionErrors = {
	title: "Erros de emissão",
	period: "Período",
	export: "Exportar Excel",
	drawer: {
		title: "Histórico de erros",
		message: "Mensagem",
		type: "Tipo de erro",
		profile: "Perfil fiscal",
		count: "Quantidade",
		date: "Primeiro dia não emitido",
		updatedAt: "Último dia não emitido",
		status: "Status",
		attemptsTitle: "Últimas tentativas de emissão",
		productsTitle: "Produtos não emitidos",
		noAttempts: "Nenhuma tentativa de emissão encontrada",
		noProducts: "Nenhum produto não emitido encontrado",
		attemptsTable: {
			client: "Cliente",
			date: "Data",
			error: "Erro",
		},
		productsTable: {
			product: "Produto",
			count: "Quantidade",
		},
	},
	tabs: {
		invoices: "Notas não emitidas",
		products: "Produtos não emitidos",
	},
	table: {
		statusLabel: {
			pending: "Pendente",
			resolved: "Resolvido",
		},
		errorTypeLabel: {
			unknown: "Desconhecido",
		},
		columns: {
			errorMessage: "Mensagem",
			errorType: "Tipos de erro",
			fiscalProfileId: "Perfil fiscal",
			count: "Quantidade",
			createdAt: "Primeiro dia não emitido",
			updatedAt: "Último dia não emitido",
			status: "Status",
		},
	},
};
